import { redirect } from 'react-router-dom';
import { store } from '@/store/store';

export async function rootLoader() {
  console.log('[rootLoader] Executing root loader...');

  const state = store.getState();
  const { isAuthenticated, verifiedStores } = state.auth;

  console.log('[rootLoader] Auth state:', {
    isAuthenticated,
    verifiedStoresCount: verifiedStores.length,
  });

  if (!isAuthenticated) {
    console.log('[rootLoader] Not authenticated, redirecting to /auth/login');
    return redirect('/auth/login');
  }

  if (verifiedStores.length === 0) {
    console.log('[rootLoader] No stores, redirecting to /auth/store-selector');
    return redirect('/auth/store-selector');
  }

  if (verifiedStores.length === 1) {
    const singleStore = verifiedStores[0];
    if (singleStore.authorized === true) {
      console.log('[rootLoader] Single authorized store, redirecting to dashboard');
      return redirect(`/${singleStore.storeType}/${singleStore.storeId}/dashboard`);
    }
  }

  console.log('[rootLoader] Multiple stores, redirecting to /auth/store-selector');
  return redirect('/auth/store-selector');
}
